import { Message } from "@moe/priv/model/message";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useAppContext } from "@web/route-services/root/AppContext";
import { historyPageSize } from "./History";

export const useHistoryQuery = (chatID: number) => {
  const { access } = useAppContext();

  return useInfiniteQuery<Message[]>({
    queryKey: ["chatHistory", chatID],
    queryFn: async ({ pageParam }) => {
      const page = pageParam as number;
      return await access.message.getPageByChatID(chatID, {
        page,
        pageSize: historyPageSize,
        order: "desc"
      });
    },
    getPreviousPageParam(firstPage, _allPages, firstPageParam) {
      if (firstPage.length < historyPageSize) return undefined;
      return (firstPageParam as number) + 1;
    },
    getNextPageParam: () => undefined,
    initialPageParam: 0
  });
};
